<div class="card">
  <input
    #participantIdentifier
    type="text"
    class="input"
    placeholder="請輸入參加者識別碼"
  />
  <select #trialSequenceNumber class="input">
    <option value="" disabled selected>選擇測試序列</option>
    <option value="1">序列 1</option>
    <option value="2">序列 2</option>
    <option value="3">序列 3</option>
    <option value="4">序列 4</option>
    <option value="5">序列 5</option>
    <option value="6">序列 6</option>
  </select>
  <button
    (click)="goToExperiment(participantIdentifier.value, trialSequenceNumber.value)"
    class="button primary"
  >
    開始測試
  </button>
</div>
